import React, { Fragment, ReactNode, useState } from "react";
import Tabs from "../../Tabs/Tabs";
import General from "./Tabs/General";
import Provider from "./Tabs/Provider";
import BankDetails from "./Tabs/BankDetails";
import OutwardTransactions from "./Tabs/OutwardTransactions";
import { useFetchOutwardTransferProviders } from "../../../custom-hooks/useFetchOutwardTransferProviders";
import { Loader } from "../../../UI/Loaders/Loaders";

const MFBTransactionSettings = () => {
  const [state, setState] = useState({
    activeTab: "general",
    tabs: [
      {
        name: "General",
        id: "general",
        icon: "fas fa-globe",
        identifier: "mfbTransactionSettingsTab",
      },
      {
        name: "Provider",
        id: "provider",
        icon: "fas fa-server",
        identifier: "mfbTransactionSettingsTab",
      },
      {
        name: "Bank Details",
        id: "bank details",
        icon: "fas fa-university",
        identifier: "mfbTransactionSettingsTab",
      },
      {
        name: "Outward Transactions",
        id: "outward transactions",
        icon: "fas fa-exchange-alt",
        identifier: "mfbTransactionSettingsTab",
      },
    ],
  });

  const toggleTabContent = (content: string) => {
    setState((prev) => {
      return {
        ...prev,
        activeTab: content,
      };
    });
  };

  const {
    data: transferProviders,
    isLoading: isLoadingTransferProviders,
    isError,
  } = useFetchOutwardTransferProviders();

  const componentMap: Record<string, ReactNode> = {
    general: <General transferProviders={transferProviders} />,
    provider: <Provider transferProviders={transferProviders} />,
    "bank details": <BankDetails transferProviders={transferProviders} />,
    "outward transactions": <OutwardTransactions />,
  };

  let renderContent = null;
  if (isLoadingTransferProviders) {
    renderContent = <Loader centered={true} text="Loading transactions..." />;
  } else if (isError) {
    renderContent = (
      <div className="centerLoader">
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt p-y-5">
            There was an error loading transactions. Please try again.
          </h4>
        </div>
      </div>
    );
  } else {
    renderContent = (
      <Fragment>
        <Tabs onContentToggle={toggleTabContent} tabs={state?.tabs} />

        <div className="row clearfix grid__padding">
          {componentMap[state.activeTab] ?? null}
        </div>
      </Fragment>
    );
  }

  return <div className="speed-1x fadeInRight">{renderContent}</div>;
};

export default MFBTransactionSettings;
